import { render } from "./SectionDnaRepair1.vue?vue&type=template&id=aca58c32"
import script from "./SectionDnaRepair1.vue?vue&type=script&lang=js"
export * from "./SectionDnaRepair1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__